/**
 * @module app.stateservice
 */
const StateService = class {

  /**
   * see https://ui-router.github.io/guide/transitionhooks
   */

  /**
   * @param {string} defaultState name.
   * @return {string} from state name.
   */
  getTransitionFrom(defaultState) {
    return StateService.from || defaultState;
  }

  /**
   * @param {string} defaultState name.
   * @return {string} to state name.
   */
  getTransitionTo(defaultState) {
    return StateService.to || defaultState;
  }

};

// listen to ui-router $transitions onSuccess event
export default angular.module('appStateservice', []).service('appStateservice', StateService).run(['$transitions', function($transitions) {

  $transitions.onSuccess({}, function(transition) {
    StateService.from = transition.from().name;
    StateService.to = transition.to().name;
  });

}]);
